import React from "react";
import Reveal from "./Reveal";

/**
 * Reusable page-top hero with eyebrow / title / lede over a dark image.
 */
export default function PageHero({ eyebrow, title, lede, image, testId = "page-hero" }) {
  return (
    <section
      data-testid={testId}
      className="relative pt-32 pb-24 sm:pt-40 sm:pb-32 overflow-hidden bg-[#070B14]"
    >
      <div className="absolute inset-0">
        <img
          src={image}
          alt=""
          className="w-full h-full object-cover opacity-40"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#070B14]/70 via-[#070B14]/85 to-[#070B14]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <Reveal>
          <div className="text-[11px] tracking-[0.32em] uppercase text-[#D4AF37] hairline">
            {eyebrow}
          </div>
        </Reveal>
        <Reveal delay={120}>
          <h1 className="mt-6 font-serif-display text-white text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-4xl">
            {title}
          </h1>
        </Reveal>
        {lede && (
          <Reveal delay={240}>
            <p className="mt-8 max-w-2xl text-white/70 text-base sm:text-lg leading-relaxed font-light">
              {lede}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
